import React from 'react';
import PostNotFound from '../components/PostNotFound';

export default function NotFound() {
    return <PostNotFound />;
}